import { render } from "./BaseContainer.vue?vue&type=template&id=99ee2e60&scoped=true"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=99ee2e60&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/cap-emploi/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ee2e60"]])

export default __exports__